import React from "react";
import { Draggable } from "react-beautiful-dnd";
import Asset from "./Asset";
import { isAssetGroupIndividualOrJoint } from "./bal-helper";
import type { AssetGroup } from "@/types/types";

type DraggableAssetProps = {
  asset: AssetGroup;
  index: number;
  isNonAssetBal: boolean;
};

const DraggableAsset: React.FC<DraggableAssetProps> = ({ asset, index, isNonAssetBal }) => {
  return (
    <Draggable
      key={asset.externalCode}
      draggableId={asset.externalCode}
      index={index}
      isDragDisabled={isAssetGroupIndividualOrJoint(asset?.type) || isNonAssetBal}
    >
      {(dragProvided) => (
        <div
          style={{
            ...dragProvided.draggableProps.style,
            position: "static",
            backgroundColor: "red",
          }}
          ref={dragProvided.innerRef}
          {...dragProvided.draggableProps}
          {...dragProvided.dragHandleProps}
        >
          <Asset
            title={asset.balanceSheetName}
            accounts={asset.financialAccounts}
            isNonAssetBal={isNonAssetBal}
            assetGroupId={asset.externalCode}
            assetsTotal={asset.total}
          />
        </div>
      )}
    </Draggable>
  );
};

export default DraggableAsset;
